import { create } from 'zustand';
import { combine, devtools } from 'zustand/middleware';
import type { AvailableEV } from '@/modules/new/booking/NewBookingProvider';

export const useEVStore = create(
  devtools(
    combine(
      {
        selectedEVId: null as AvailableEV['_id'] | null,
      },
      (set) => ({
        setSelectedEVId: (selectedEVId: AvailableEV['_id'] | null) => {
          set({ selectedEVId });
        },
      })
    )
  )
);
